import { apiCall, apiCallAdmin } from "../../services/api-service.js";


export const exportdata = async (data, apivalue) => {
    return await apiCall("POST", `${apivalue}/report`, data);
};
export const savetempalteApi = async (data) => {
    return await apiCallAdmin("POST", `export_template`, data);
};
export const exportquickApi = async (apivalue) => {
    return await apiCall("GET", `report/${apivalue}`);
};


export const getquickreportApi = async () => {
    const response = await apiCall("GET", `report/get_quick_report`);
    return response.data;
};
export const getTempalteApi = async () => {
    const response = await apiCallAdmin("GET", `export_template?application=Gate`);
    return response.data;
};
export const getDownloadReportApi = async () => {
    const response = await apiCallAdmin("GET", `downloaded_reports?type=Gate`);
    return response.data;
};
export const getExportfieldApis = async (id) => {
    const response = await apiCallAdmin("GET", `export_template/${id}`);
    return response.data;
};
export const getExportdownloadApis = async (id) => {
    const response = await apiCallAdmin("GET", `downloaded_reports/${id}`);
    return response.data;
};


export const downloadBase64File = (base64String, fileName) => {
    if (!base64String) return;
    const cleanBase64 = base64String.includes(",") ? base64String.split(",")[1] : base64String;
    const binary = atob(cleanBase64);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const link = document.createElement('a');
    const blobUrl = URL.createObjectURL(blob);
    link.href = blobUrl;
    link.download = fileName || `Report_${Date.now()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
};

export const downloadFileFromUrl = async (url, fileName) => {
    if (!url) return;
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName || `Report_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
    } catch (error) {
        console.warn("Direct blob fetch failed, falling back to direct download link:", error);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName || `Report_${Date.now()}.xlsx`;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
};

export const downloadReportFile = async (data, defaultFileName = "Report") => {
    if (!data) return false;
    const fileName = data.file_name || `${defaultFileName}_${Date.now()}.xlsx`;
    if (data.base64) {
        downloadBase64File(data.base64, fileName);
        return true;
    }
    const fileUrl = data.url || data.file_url || data.download_url || data.filePath;
    if (fileUrl) {
        await downloadFileFromUrl(fileUrl, fileName);
        return true;
    }
    return false;
};

